import { Component, OnDestroy } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { Subject, takeUntil } from 'rxjs';
import { MemberService } from '../../../../core/services/member.service';

@Component({
  selector: 'ms-accept-invitation',
  imports: [],
  templateUrl: './accept-invitation.component.html'
})
export class AcceptInvitationComponent implements OnDestroy {

  private readonly destroy$ = new Subject<void>();
  private token: string = "";

  constructor(
    private activatedRoute: ActivatedRoute,
    private memberService: MemberService,
    private router: Router
  ) { }

  public ngOnInit(): void {
    this.activatedRoute.queryParams
      .pipe(takeUntil(this.destroy$))
      .subscribe(params => {
        this.token = params['token'] || "";
      });

    this.acceptInvitation();
  }
  
  private async acceptInvitation(): Promise<void> {
    const response = await this.memberService.acceptMemberInvitation(this.token);

    if (response.success === true && response.data === undefined) {      
      this.router.navigate(['/sign-in']);
    } else if (response.success === true && response.data?.resetLink) {
      this.redirectToPasswordReset(response.data.resetLink);
    } else {
      this.router.navigate(['/system/invitation-error'], {
        state: { 
          errorMessage: response.message || 'An error occurred while accepting the invitation.'
        }
      });
    }
  }

  private redirectToPasswordReset(resetLink: string): void {
    window.location.href = resetLink;
  }

  public ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }
}
